// import React, { useEffect,useRef } from 'react';
// import './intro.css';
// import bg from '../../asset/info.png';
// import {Link} from 'react-scroll';
// import btnImg from '../../asset/BgImg.png'
// import Typed from "typed.js";

// const Intro = () => {
//     const typedRef=useRef(null)
//     useEffect(() => {
//         const options={
//             strings: ["Welcome to my website", "I'm a web developer"],
//             typeSpeed: 50,
//             backSpeed: 50,
//             loop: true

//         }
//         const typed=new typed(typedRef.current,options)
//         return () => {
//             typed.destroy()
//         }
//     },[])
//   return (
//     <section className="info">
//         <div className="infoContent">
//             <span className="hello">Hello</span>

//             <span className="introText">I'm <span className="introName"></span></span>
//             <p className="introPara">I am a skilled and passionate web designer with expirence <br />in creating visual appealing and user friendly website</p>
//             <Link><button className='btn'><img src={btnImg} alt='Profile' className='btnImg'/> Hire me</button> </Link>
//         </div>
//         <img src={bg} alt="Profile"  className='bg'/>

       
//     </section>
// )
// }

// export default Intro

import React, { useEffect, useRef } from 'react';
import './intro.css';
import bg from '../../asset/info.png';
import { Link } from 'react-scroll';
import btnImg from '../../asset/BgImg.png';
import Typed from 'typed.js';

const Intro = () => {
    const typedRef = useRef(null);

    useEffect(() => {
        const typed = new Typed(typedRef.current, {
            strings: ["Coder", "Developer", "Web Designer"],
            typeSpeed: 50,
            backSpeed: 50,
            loop: true
        });

        return () => {
            typed.destroy();
        };
    }, []);

    return (
        <section className="info">
            <div className="infoContent"
            data-aos="fade-up-right"
            data-aos-duration="1000">
                <span className="hello">Hello</span>

                <span className="introText">
                    I'm <span className="introName" ref={typedRef}></span>
                </span>

                <p className="introPara">
                    I am a skilled and passionate web designer with experience <br />
                    in creating visually appealing and user-friendly websites.
                </p>

                <Link>
                    <button className='btn'>
                        <img src={btnImg} alt='Profile' className='btnImg' /> Hire me
                    </button>
                </Link>
            </div>
            <img src={bg} alt="Profile" className='bg' data-aos="fade-down-left"
            data-aos-duration="1000"></img>
        </section>
    );
};

export default Intro;
